<template>
  <div class="needDetail full-height linear-main3">
    <ld-header
      :transparent="true"
      :white="true"
      @click-left="back"
    >
      {{ $t('A106','需求单') }}
    </ld-header>
    <div class="tkNeedwrapper full-width">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="content">
          <div>
            <van-cell
              v-for="(rg,index) in orderInfo.tkNeedOrderRanges"
              :key="index"
            >
              <span>{{ rg.departTime }} {{ rg.departTime|week }}</span>
              <span class="fr">{{ orderInfo.orderStatusRemark }}</span>
              <div>{{ rg.departCityName }} - {{ rg.arriveCityName }}</div>
              <div>{{ orderInfo.psgType|psgType }}</div>
              <div>{{ orderInfo.cabin|cabin }}</div>
            </van-cell>
          </div>
          <div>
            <van-cell title="出行人数" />
            <van-cell>
              <span>{{ orderInfo.adultNum }} {{ $t('C115','成人') }}  </span>
              <span v-show="orderInfo.childNum>0"> {{ orderInfo.childNum }} {{ $t('C116','儿童') }}  </span>
              <span v-show="orderInfo.babyNum>0">{{ orderInfo.babyNum }} {{ $t('C117','婴儿') }}  </span>
            </van-cell>
          </div>
          <div>
            <van-cell :title="$t('H417','您的需求')" />
            <van-cell>{{ orderInfo.content }}</van-cell>
          </div>
          <div>
            <!-- 联系信息 -->
            <van-field
              :label="$t('D022','联系信息')"
              :readonly="true"
            >
              <div slot="input">
                {{ orderInfo.linkman }} ({{ orderInfo.linkTel || orderInfo.linkMobile }})
                            
                <div class="font12 gray">
                  {{ $t('D020','邮箱') }} ({{ orderInfo.linkEmail }})
                </div>
              </div>
            </van-field>
          </div>
          <div>
            <van-panel :title="$t('H404','留言板')">
              <p
                class="text-center"
                v-show="noteList.length<1"
              >
                {{ $t('H418','暂无内容,更多需求请留言。') }}
              </p>
              <div
                v-for="(info,index1) in noteList"
                :key="index1"
                class="pad-6"
              >
                <div v-show="info.direction=='left'">
                  <h6 class="text-center">
                    {{ info.noteDate }}
                  </h6>
                  <div class="clear">
                    <div
                      class="text-left"
                      style="line-height: 26px;"
                    >
                      <span class="blue text-left ">{{ $t('A114','客服') }}</span>
                    </div>
                    <div class=" text-left break-all">
                      <span class="text-left txtChat">{{ info.note }}</span>
                    </div>
                  </div>
                </div>
                <div v-show="info.direction=='right'">
                  <h6 class="gray text-center">
                    {{ info.noteDate }}
                  </h6>
                  <div>
                    <div
                      class=" text-right  padL15"
                      style="line-height: 26px;"
                    >
                      <span class="main-color text-left ">{{ info.noteBy }}</span>
                    </div>
                    <div class=" text-right break-all">
                      <span class="text-left txtChat right bor-blue">{{ info.note }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </van-panel>
          </div>
        </div>
      </mescroll-vue>
    </div>
    <!--  -->
    <ld-tabbar class="shadow">
      <van-field
        v-model="noteTxt"
        center
        clearable
        placeholder="请输入留言"
      >
        <van-button
          slot="button"
          size="small"
          type="primary"
          @click="saveNote"
        >
          {{ $t('B046','发送') }}
        </van-button>
      </van-field>
    </ld-tabbar>
  </div>
</template>
<script>
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import MescrollVue from 'mescroll.js/mescroll.vue'
import { mapGetters } from 'vuex'
import { Cell ,Panel ,Field,Button} from 'vant'

export default {
  name: 'NeedDetail',
  data(){
    return {
      'htSearchInfo':'',//搜索信息
      'orderInfo':'',
      'empInfo':'',
      'noteList':'',
      'noteTxt':'',
      down:{use:false}
    }
  },
  components: {
    ldButton,
    ldTabbar,
    MescrollVue,
    [Cell.name]:Cell,
    [Panel.name]:Panel,
    [Field.name]:Field,
    [Button.name]:Button,
  },
  computed:{
    ...mapGetters({
      tripType: 'tripType',
      userInfo:'userInfo'
    }),
    orderId(){
      return  this.$route.query.orderId//'dc943538fac0403cba1844ed87f3f9bb' //
    }
  },
  created:function(){
    this.init()
  },
  methods:{
    init(){
      this.$api['tkIntOrder/tkNeedOrderDetail']({
        orderId:this.orderId
      }).then((res) => {
        this.orderInfo=res.data||{}
      })
      this.findHtNeedNote()
    },
    cancel(){
      this.$toast('订单已取消')
    },
    back:function(){
      this.$router.push({path:'/userCenter/NeedOrder'})
    },
    saveNote(){
      if(!this.noteTxt){
        this.$toast('输入内容为空！')
        return false
      }
      this.$api['htQuery/savehtNeedNote']({
        'orderId':this.orderId,
        note:this.noteTxt
      }).then(() => {
        this.findHtNeedNote()
        this.noteTxt=''
      })
    },
    findHtNeedNote(){
      this.$api['htQuery/findHtNeedNote']({
        'orderId':this.orderId,
        note:this.noteTxt
      }).then((res) => {
        var cache=res.data||[]
        this.noteList=cache.sort(function(a,b){
          var r=a.noteDate>b.noteDate
          return r?'1':-1
        })
        for (var i=0;i<this.noteList.length;i++) {
          if(this.noteList[i].czly==1){
            this.noteList[i].direction='right'
          }else{
            this.noteList[i].direction='left'
          }
        }
      })
    }
  },
  filters:{
    psgType(type){
      let arr=['','普通成人','劳务','留学生','新移民']
      return arr[type]
    },
    cabin(cabin){
      let arr=['','头等舱','公务舱','经济舱']
      return arr[cabin]
    }
  }
}
</script>
<style lang="less" scoped>
.needDetail{
    .content{
        padding: 0 6px;
        padding-bottom: 50px;
        >div{
            padding-bottom: 5px;
        }
    }
    .pad-6{
        padding: 6px;
    }
    .tkNeedwrapper{
        height: calc(100vh - 96px);
        overflow: hidden;
    }
}
</style>